<template>
  <div
    class="gift_show"
  >
    <div class="swiperLottery">
      <img src="../../../assets/saveCardActivity/fuli1.png" alt="" />
    </div>
    <!-- <p>您还有 {{ state.lotteryCount }} 次抽奖机会</p> -->
    <div class="lotteryBtn">
      <img
        src="../../../assets/saveCardActivity/icon_lottery_no.png"
        alt=""
        @click="receive"
        v-if="!state.is_received"
      />
      <img
        src="../../../assets/saveCardActivity/icon_lottery.png"
        alt=""
        v-else
      />
    </div>

    <div class="lotterytip">
      <span>在《仙灵物语0.1折》游戏中角色等级达40级</span>
      <span>可领取7天省钱卡（价值20元）</span>
      <span>每人限领一次，具体请查看详细规则。</span>
      <span>活动截止：2025年10月10日23:59</span>
    </div>
  </div>

  <div class="gift_lottery">
    <van-popup v-model:show="state.popShow" @close="popshowClose">
      <div class="popContent">
        <div class="card" ref="giftCard">
          <img
            :src="
              `https://oss.zhekoushenqi.com/data/homegameActivity/icon_lottery_card.png?t=${props.nowDay}`
            "
            alt=""
            @click="showGift"
          />
          <img :src="state.myPrize" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script setup>
import "swiper/swiper-bundle.min.js";
import { Swiper, Pagination, Autoplay } from "swiper";
import { onMounted, ref, reactive, nextTick, watch, watchEffect } from "vue";
import "swiper/modules/effect-creative/effect-creative.min.css";
import { getactivityDraw, getactivityInfo } from "@/api/activity";
import { detect } from "@/utils/device";
import { Toast } from "vant";
import { checkReceivedStatus, receiveShengqianka } from "../../../api/activity";
import { getToken } from "../../../utils/auth";

const state = reactive({
  popShow: false,
  lotteryCount: 0,
  lotteryList: [],
  is_received: false,
  myPrize: "",
  isClick: false
});

const props = defineProps({
  lotteryNum: {
    type: Number,
    default: 0,
  },
  token: {
    type: String,
    default: "",
  },
  nowDay: {
    type: String,
    default: "",
  },
  lotteryList: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["getActivity"]);
watch(props, (newVal, oldVal) => {
  // console.log("抽奖次数newVal", newVal);
  state.lotteryCount = newVal.lotteryNum;
  state.lotteryList = newVal.lotteryList;
  nextTick(() => {
    // mySwiper && mySwiper.destroy();
    // initSwiper();
  });
});

let giftCard = ref(null);
const showGift = () => {
  // 添加css动画，翻转180deg
  giftCard.value.style.transform = "rotateY(180deg)";
  giftCard.value.style.transition = "transform 1.5s";
};
const popshowClose = () => {
  giftCard.value.style.transform = "rotateY(0deg)";
};

onMounted(() => {
  nextTick(() => {
    // initSwiper();
    checkStatus();
  });
});

const checkStatus = ()=>{
  checkReceivedStatus({token: props.token}).then(res=>{
    // console.log(res)
    if(res.data.code == 1){
      state.is_received = res.data.data.is_received
    }
  })
}

const receive = ()=>{
  if(state.isClick){
    return
  }
  state.isClick = true
  receiveShengqianka({token: props.token}).then(res=>{
    Toast(res.data.msg)
    if(res.data.code == 1){
      checkStatus()
    }
  }).finally(()=>{
    state.isClick = false
  })
}

var mySwiper = "";
var slides = ref(null);

Swiper.use([Pagination, Autoplay]);
const initSwiper = () => {
  mySwiper = new Swiper(".swiperLottery", {
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
    centeredSlides: true,
    slidesPerView: 2.5,
    spaceBetween: 10,
  });
};

// 抽奖阻断按钮
var startFlag = false;
const startLottery = async () => {
  // console.log("获取本地存的token-----", props.token);

  if (startFlag) return;
  startFlag = true;
  // 抽奖开始
  let res = await getactivityDraw({
    token: props.token,
  });
  startFlag = false;
  if (res.data.code == "1") {
    // 更新抽奖次数
    if (state.lotteryCount > 0) {
      state.lotteryCount--;
    }
    // 挑选0-3
    // let num = Math.floor(Math.random() * 7);
    // console.log(num);
    state.popShow = true;
    state.lotteryList.filter((item, index) => {
      if (index == res.data.data.pnum) {
        state.myPrize = item.image;
      }
    });
  } else {
    Toast.fail(res.data.msg);
  }
  emit("getActivity");
};

// 触摸事件
const touchAction = (e) => {
  if (detect() == "android" || detect() == "harmony") {
    // window.document.location = "disPatchTouchViewPager://" + true;

    window.JsBridge.disPatchTouchViewPager(true);
  }
};
</script>
<style scoped>
.gift_show {
  height: 762px;
  width: 100vw;
  background-image: url('../../../assets/saveCardActivity/test2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-top: 150px;
}
.gift_show p {
  width: 100%;
  text-align: center;
  color: #fff;
  margin-top: -15px;
}
.gift_show .lotteryBtn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.gift_show .lotteryBtn img {
  width: 292px;
}
.gift_show .lotterytip {
  color: white;
  margin-top: 42px;
  font-size: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/* 弹出层 */
:deep(.van-popup) {
  background: none;
}
:deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.6);
}
.popContent {
  height: 624px;
  width: 416px;
}
.popContent .card {
  position: relative;
  width: 100%;
  height: 100%;
  /* 设置为3d盒子 */
  transform-style: preserve-3d;
  perspective: 1000px;
}
.card img {
  position: absolute;
  /* 设置背部不可见 */
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.card img:nth-of-type(2) {
  transform: rotateY(180deg);
}

.swiperLottery {
  /* width: 500px; */
  height: 280px;
  touch-action: pan-y pinch-zoom;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
}
.swiperLottery img {
  width: 374px;
}

.swiperLottery .swiper-wrapper {
  height: 280px;
  padding-top: 10px;
}
.swiperLottery div div {
  width: 100%;
  height: 430px;
  border-radius: 20px;
}
.swiper-slide-active {
  color: #fff;
}

.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.9);
}
.swiper-slide img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1.15);
}
</style>
